import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ActivateBrandTermsBatch($ids: [ID!]!) {
    activateBrandTermsBatch(ids: $ids)
  }
`;

export const activateBrandTermsBatch = ({ ids }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { ids },
  }).then(({ data }) => getSingleProp(data));
};
